import React, { useEffect, useState } from "react";
import { fetchCollectionAction } from "state/actions/collectionActions";
import { REWARDS_HISTORY } from "state/constants/actions";
import { useDispatch, useSelector } from "react-redux";
import { requestRewardsHistory } from "apis/rewards";
import AccountPointHistory from "../components/AccountPointHistory";
import { useAuth0 } from "@auth0/auth0-react";
import { getUserPointsHistory } from "../apis/middlewareEndpoints";

const RewardsHistory = ({ ...props }) => {
  const [currentPage, setCurrentPage] = useState("1");
  const [defaultPerPage, setDefaultPerPage] = useState(10);
  const { collection: rewards_history, uiState, error } = useSelector(
    (state) => state.rewards_history
  );

  const dispatch = useDispatch();
  useEffect(() => {
    if (process.env.GATSBY_ENABLE_AUTH0 !== "true") {
      fetchCollectionAction(REWARDS_HISTORY, dispatch, requestRewardsHistory, {
        page: currentPage,
        per_page: defaultPerPage,
      });
    }
  }, [currentPage, defaultPerPage]);

  const { isAuthenticated, getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    if (process.env.GATSBY_ENABLE_AUTH0 === "true") {
      if (isAuthenticated) {
        const getMemberPoints = async () => {
          const token = await getAccessTokenSilently();

          fetchCollectionAction(
            REWARDS_HISTORY,
            dispatch,
            getUserPointsHistory,
            {
              page: currentPage,
              per_page: defaultPerPage,
              token,
            }
          );
        };

        getMemberPoints();
      }
    }
  }, [currentPage, isAuthenticated, getAccessTokenSilently, defaultPerPage]);

  return (
    <AccountPointHistory
      data={rewards_history}
      langData={props.langData}
      currentPage={currentPage}
      defaultPerPage={defaultPerPage}
      setCurrentPage={setCurrentPage}
      setDefaultPerPage={setDefaultPerPage}
      openWidgetAction={props.openWidgetAction}
    />
  );
};

export default RewardsHistory;
